import React from 'react';
import classNames from 'classnames';

import Loading from '../../shared/Loading';
import { formatCurrency } from '../../../lib/utils/formatters';

export default function EntityOverview({ props }) {
  let statusColor;
  const { type, entity, stats, errors } = props;
  const status =
    type === 'company' ? entity?.underwriting_status : entity?.status;

  switch (status) {
    case 'approved':
      statusColor = 'bg-green-100 text-positive-green';
      break;
    case 'declined':
      statusColor = 'bg-red-100 text-negative-red';
      break;
    case 'hold':
    case 'pending':
      statusColor = 'bg-yellow-100 text-burnt-yellow';
      break;
    default:
      statusColor = 'bg-blue-100 text-primary-blue';
      break;
  }

  const getDisplay = () => {
    if (!stats && !errors.statsError) {
      return <Loading className="w-7 h-7" />;
    } else if (errors.statsError) {
      return;
    } else {
      return (
        <>
          <p className="capitalize mx-1">
            Credit Utilized:{' '}
            {formatCurrency(stats?.credit_utilized)} |{' '}
          </p>
          <p className="capitalize mx-1">Active Orders: {stats?.active} | </p>
          <p className="capitalize mx-1">Closed Orders: {stats?.closed}</p>
        </>
      );
    }
  };

  return (
    <div>
      <div className="flex items-center">
        <p
          className={classNames('text-4xl font-avenir-black text-navy-blue', {
            'ph-no-capture': type !== 'company',
          })}
        >
          {entity?.name}
        </p>
        <span
          className={classNames(
            'inline-flex items-center rounded-md mx-3 mb-1 px-3 pt-2 py-1.5 uppercase font-avenir-medium tracking-wide',
            statusColor,
          )}
        >
          {status}
        </span>
      </div>
      <div className="flex items-center font-avenir-medium text-base lg:text-xl my-2">
        <p className="capitalize mx-1">
          {entity?.tier.includes('_')
            ? entity?.tier.replace('_', ' ')
            : `Tier ${entity?.tier}`}{' '}
          |{' '}
        </p>
        <p className="capitalize mx-1">
          TCL:{' '}
          {formatCurrency(
            type === 'company'
              ? entity?.approved_credit_limit
              : entity?.tier_limit,
          )}{' '}
          |{' '}
        </p>
        {getDisplay()}
      </div>
    </div>
  );
}
